import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
const pathA = ["Keep wasting $50-100 on meat that doesn't turn out", 'Keep Googling contradictory advice at 2 AM', 'Keep hiding behind sauce and seasoning', 'Keep seeing that look of polite disappointment', "Keep wondering what competition guys know that you don't"];
const pathB = ['Nail perfect bark, smoke ring, and tenderness every single time', 'Become the person everyone begs to host the cookout', 'Save hundreds by not over-buying gadgets and wasted meat', 'Cook with confidence and actual understanding of the science', 'Join a community of serious backyard pitmasters'];
export function TwoPaths() {
  const scrollToFinalCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 md:py-20 px-4 bg-dark-contrast" data-id="element-224">
      <div className="max-w-5xl mx-auto" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-226">
          <h2 className="font-heading text-4xl md:text-6xl font-black text-ivory uppercase tracking-tight" data-id="element-227">
            You Have Two Paths Right Now
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 md:mb-12" data-id="element-228">
          {/* Path A */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark border border-[#333] rounded-2xl p-6 md:p-10 opacity-80" data-id="element-229">
            <h3 className="font-heading text-xl md:text-3xl font-bold text-smoke mb-6 md:mb-8 pb-4 md:pb-6 border-b border-[#333] uppercase tracking-tight" data-id="element-230">
              Path A: Keep Guessing
            </h3>
            <ul className="space-y-4 md:space-y-8" data-id="element-231">
              {pathA.map((item, index) => <li key={index} className="flex items-start gap-4 md:gap-5" data-id="element-232">
                  <XCircleIcon className="w-6 h-6 md:w-7 md:h-7 text-red-600 shrink-0 mt-0.5" data-id="element-233" />
                  <span className="text-smoke leading-relaxed text-base md:text-lg" data-id="element-234">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Path B */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-dark-elevated border-2 border-amber/60 rounded-2xl p-6 md:p-10 relative shadow-[0_0_40px_rgba(230,157,79,0.1)]" data-id="element-235">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-cta-start to-cta-end text-dark px-4 md:px-6 py-1.5 rounded-full font-black text-xs md:text-sm uppercase tracking-widest whitespace-nowrap" data-id="element-236">
              The Smart Choice
            </div>
            <h3 className="font-heading text-xl md:text-3xl font-bold text-ivory mb-6 md:mb-8 pb-4 md:pb-6 border-b border-[#333] uppercase tracking-tight" data-id="element-237">
              Path B: Master the Flame
            </h3>
            <ul className="space-y-4 md:space-y-8" data-id="element-238">
              {pathB.map((item, index) => <li key={index} className="flex items-start gap-4 md:gap-5" data-id="element-239">
                  <CheckCircleIcon className="w-6 h-6 md:w-7 md:h-7 text-green-500 shrink-0 mt-0.5" data-id="element-240" />
                  <span className="text-ivory font-medium leading-relaxed text-base md:text-lg" data-id="element-241">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-242">
          <button onClick={scrollToFinalCTA} className="w-full sm:w-auto bg-gradient-to-r from-[#F2B851] to-[#C45F2A] border-b-4 border-[#964215] rounded-md text-[#0F1111] font-black uppercase text-base sm:text-xl md:text-2xl py-4 md:py-5 px-6 md:px-16 shadow-[0_0_25px_rgba(242,184,81,0.4)] hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0.5 active:border-b-2 transition-all duration-200" data-id="element-243">
            🔥 CHOOSE PATH B →
          </button>
        </motion.div>
      </div>
    </section>;
}